import { VideoRenderDto } from "@repo/api/video-render";

export function getStatus(
  videoRender: VideoRenderDto | null,
): "rendering" | "failed" | "done" {
  if (
    !videoRender ||
    videoRender.status === "rendering" ||
    videoRender.status === "upscaling"
  ) {
    return "rendering";
  }

  if (videoRender.status === "failed") {
    return "failed";
  }

  if (videoRender.status === "done") {
    return "done";
  }

  return "rendering";
}

export function getTitle(videoRender: VideoRenderDto | null) {
  const status = getStatus(videoRender);

  if (status === "failed") {
    return "Failed to render video";
  }

  if (status === "done") {
    return "Video rendered successfully";
  }

  return "Your video is being rendered...";
}

export function getDescription(
  videoRender: VideoRenderDto | null,
): string | React.ReactNode {
  const status = getStatus(videoRender);

  if (status === "failed") {
    return "Please try again or contact support.";
  }

  if (status === "done") {
    return "Your video is now ready to be shared with others.";
  }

  return "Video will download automatically once rendering is complete.";
}
